import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

export const leftBarFinanceItems = [
  {
    permissionName: 'account-payable',
    allLinkName: 'dashboard_account_payable',
    sectionIcon: <AccountBalanceWalletIcon />,
    sectionTitleTKey: 'right_menu_link_account_payable',
  },
];
